export default __webpack_public_path__ + "navigation-examples-custom-segue-1200-bac9e4306832e853f1d195dcd68ef509.png";